var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentlyLivingIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.152,
    height: 20.152,
    viewBox: "0 0 20.152 20.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17156",
    "data-name": "Group 17156",
    transform: "translate(-376 -284)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    width: 20.152,
    height: 20.152,
    transform: "translate(376 284)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "office-push-pin",
    d: "M16.876,4.662,12.337.123a.42.42,0,0,0-.594,0l-.019.019A1.473,1.473,0,0,0,11.476,1.9L6.727,5.973a1.982,1.982,0,0,0-2.721.078l-.028.028a.42.42,0,0,0,0,.594L6.7,9.393,4.049,12.041C4,12.1,2.742,13.388,1.918,14.416c-.785.979-.94,1.158-.948,1.167a.42.42,0,0,0,.593.593c.007-.006.182-.158,1.167-.948,1.028-.824,2.32-2.078,2.378-2.135l2.644-2.644,2.574,2.574a.42.42,0,0,0,.594,0l.028-.028a1.982,1.982,0,0,0,.078-2.721L15.1,5.523a1.473,1.473,0,0,0,1.755-.248l.019-.019A.42.42,0,0,0,16.876,4.662Z",
    transform: "translate(377.134 286)",
    fill: "#3f2566"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentlyLivingIn);
export default __webpack_public_path__ + "static/media/currently_living_in.d00327cec9fa33b63474cc5a9d06471d.svg";
export { ForwardRef as ReactComponent };